import React from "react"
import styled from "styled-components"
const Map = ({ lat, lon }) => {
  return (
    <Wrapper>
      <iframe
        title="Moverbility Map"
        src={`https://maps.google.com/maps?q=${lat},${lon}&hl=es;z=20&output=embed`}
        /* "https://www.google.com/maps/place/California+Movers+Local+&+Long+Distance+Moving+Company/data=!4m5!3m4!1s0x808580936cc0ce73:0x5bc9aca9f96df248!8m2!3d37.7903514!4d-122.4170668?authuser=0&hl=en&rclk=1" */
        width="100%"
        height="450"
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        style={{ border: 0 }}
      ></iframe>
    </Wrapper>
  )
}

export default Map

const Wrapper = styled.div`
  iframe {
    border-radius: 8px;
  }
`
